// Used for strand and job-listing

class BasicFilter {
    constructor(cardSelector, btnColour) {
        this.cards = [...document.querySelectorAll('.section--feed-basic ' + cardSelector)];
        this.paginationContainer = document.querySelector('.pagination'); 
        this.btnColour = btnColour;
        this.loadMoreButton = this.createLoadMoreButton();
        this.container = document.querySelector('.feed-list'); 
        this.featuredTemplate = document.getElementById('featured-content');
        this.currentIndex = 0; 
        this.cardsPerPage = this.featuredTemplate ? 8 : 9; 
        this.filteredCards = [];
       
        this.init();
    }

    init() {
        // Reset container
        this.container.innerHTML = "";
        this.prepCards();
    }

    prepCards() {
       
        if(this.cards.length === 0) {
            return; 
        } 
        //hide and append cards
        this.cards.forEach(card => {
            card.style.display = 'none'
            this.container.append(card); 
        });

        this.displayInitalCards(); 
    }

    showFeaturedContent() {
        if (this.featuredTemplate) {
            const clone = document.importNode(this.featuredTemplate.content, true); 
            const insertPoint = this.cards.length >= 8 ?  document.querySelector('.feed-list .card:nth-child(8)') : document.querySelector('.feed-list .card:nth-child(' + this.cards.length + ')');
            const nextSibling = insertPoint.nextElementSibling;

            insertPoint.parentNode.insertBefore(clone, nextSibling);
        }
    }

    //Displays initial cards 
    displayInitalCards() {
        const initialCardCount = this.featuredTemplate ? 8 : 9; 
        const filteredCardsCount = this.cards.length;

        // Reset currentIndex if it exceeds filteredCardsCount
        if (this.currentIndex >= filteredCardsCount) {
            this.currentIndex = 0; 
        }

        // Show the initial card chunk
        const cardChunk = this.cards.slice(this.currentIndex, this.currentIndex + initialCardCount);
        cardChunk.forEach(card => {
            card.style.display = 'flex'
        });

        this.currentIndex += initialCardCount;
        this.showFeaturedContent();
        this.updateLoadMoreButton(filteredCardsCount);
    }

    createLoadMoreButton() {
        console.log(this.btnColour)
        const button = document.createElement('button');
        button.innerText = 'Load More';
        button.style.display = 'none';
        button.classList.add('btn', `btn--${this.btnColour}`);
        button.addEventListener('click', () => this.loadMoreCards());
        
        // Append button to the pagination container
        this.paginationContainer.appendChild(button);
        return button;
    }

    updateLoadMoreButton(filteredCardsCount) {
        const remainingCardCount = filteredCardsCount - this.currentIndex;
        this.loadMoreButton.style.display = remainingCardCount > 0 ? 'inline-block' : 'none'; 
    }

    //Show next card chunk
    loadMoreCards() {
        
        const remainingCards = this.cards.filter(card => card.style.display == 'none'); 
        const remainingCardCount = remainingCards.length;
        const cardChunkCount = Math.min(this.cardsPerPage, remainingCardCount); 

        // show the next cards
        for (let i = 0; i < cardChunkCount; i++) {
            remainingCards[i].style.display = 'flex';
        }

        //update index
        this.currentIndex += cardChunkCount;

        //set load more button
        if (this.currentIndex >= this.cards.length) {
            this.loadMoreButton.style.display = 'none'; 
        }
    }
}  


document.addEventListener("DOMContentLoaded", () => {
    if (document.querySelector('.section--feed-basic')) {
        const cardSelector = '.card'; 
        const btnColour = document.body.classList.contains('page-template-strand') ? 'white' : 'black';
        new BasicFilter(cardSelector, btnColour);
    } 
});

export default BasicFilter;
